import {useMemo} from 'react';

import {
  Node,
  NodeOrVoidNode,
  constFunction,
  isVoidNode,
  opGetRunTag,
  opMapEach,
  opPick,
  opRunId,
  voidNode,
  withNamedTag,
} from '@wandb/cg';

import {usePanelContext} from '.././PanelContext';

export const useColorNode = (inputNode: Node): NodeOrVoidNode => {
  const {frame} = usePanelContext();
  return useMemo(() => {
    if (frame.runColors == null || isVoidNode(frame.runColors)) {
      return voidNode();
    }
    return opMapEach({
      obj: inputNode,
      mapFn: constFunction({row: withNamedTag('run', 'run', 'any')}, ({row}) =>
        opPick({
          obj: frame.runColors as Node, // Checked above
          key: opRunId({
            run: opGetRunTag({obj: row as any}),
          }),
        })
      ),
    });
  }, [frame, inputNode]);
};
